<div class="tidy-filter-field">
  @if (label && showLabels) {
    <tidy-text [fieldLabel]="label" class="filter-label" (click)="openPanelFromLabel()" />
  }

  @if (multiple) {
    <div class="filter-container multi-select-filter" [ngClass]="activeClass" (click)="openMultiSelectFromContainer($event)">
      <tidy-image [src]="'assets/svg/filter.svg'" class="filter-icon" />
      <mat-select
        #matMultiSelect
        [value]="selectedValues"
        [multiple]="true"
        (selectionChange)="onMultiSelectChange($event)"
        (openedChange)="onMultiSelectOpened($event)"
        panelClass="tidy-filter-multi-select-panel"
        [disableOptionCentering]="true">
        <mat-select-trigger>
          {{ getMultiSelectDisplayValue() }}
        </mat-select-trigger>
        @if (items?.length > ENABLE_SEARCH_MIN_ITEMS) {
          <mat-option disabled class="filter-search-option">
            <div class="filter-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
              <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
              <input
                #multiSelectSearchInput
                type="text"
                class="search-input"
                [placeholder]="searchPlaceholder || ('Search' | translate) | translate"
                [value]="searchValue"
                (input)="onMultiSelectSearchInput($event)"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()" />
              @if (searchValue) {
                <button
                  class="clear-button"
                  (click)="clearMultiSelectSearch(); $event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </mat-option>
        }
        @for (item of filteredItems; track item) {
          <mat-option [value]="item.value">
            {{ item.viewValue | translate }}
          </mat-option>
        }
      </mat-select>
      <div class="filter-arrow">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  } @else {
    <mat-form-field [ngClass]="activeClass">
      <tidy-image [src]="'assets/svg/filter.svg'" class="filter-icon" />
      <mat-select
        [(value)]="selected"
        [(ngModel)]="value"
        (selectionChange)="onChange($event)"
        [disableOptionCentering]="true">
        @if (items?.length > ENABLE_SEARCH_MIN_ITEMS) {
          <mat-option>
            <ngx-mat-select-search
              ngModel
              (ngModelChange)="searchItems($event)"
              [placeholderLabel]="searchPlaceholder" />
          </mat-option>
        }
        @for (item of listedItems; track item) {
          <mat-option [value]="item.value">
            {{ item.viewValue | translate }}
          </mat-option>
        }
      </mat-select>
      <div class="filter-arrow">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </mat-form-field>
  }
</div>
